import React from 'react';
import initialState from "./inistial_state";



const GlobalDispatchContext = React.createContext(initialState);

export default GlobalDispatchContext;